import Consumer from "./consumer";
import store from "../checkout/redux/store";

import * as MapUtils from "../checkout/utils/MapUtils";

let connection = null;

function handleConnection(store) {
  const jwt = store.getState().checkoutStore.jwt;
  if (!jwt) return;

  let consumer = new Consumer(jwt);
  if (
    !connection &&
    window.Jumpseller != undefined &&
    window.Jumpseller.store.code
  ) {
    connection = consumer.subscriptions.create(
      {
        channel: "OrderChannel",
        room: window.Jumpseller.store.code + "_" + window.Jumpseller.store.ref,
      },
      {
        connected() {
          console.log("CONNECTED");
        },

        disconnected() {
          console.log("DISCONNECTED");
        },

        received(data) {
          switch (data["event"]) {
            case "start_delivery":
              if (
                window.initialInfo.status != "pickup_available" &&
                window.initialInfo.status != "in_preparation" &&
                window.initialInfo.status != "failed"
              )
                return;
              if (window.initialInfo.status == "failed") MapUtils.resetData();

              window.locked = true;
              MapUtils.createCourierButton();
              MapUtils.createCenterButton();
              MapUtils.setStatus(data["status"]);
              MapUtils.addMessage(data["message"]);
              MapUtils.setDeliveryTime(data["delivery_time"]);
              MapUtils.displayCoordinates([data["coordinates"]]);
              break;
            case "add_location":
              if (
                window.initialInfo.status == "delivered" ||
                window.initialInfo.status == "failed"
              )
                return;
              MapUtils.displayCoordinates([data["coordinates"]]);
              break;
            case "end_delivery":
              if (
                window.initialInfo.status == "delivered" ||
                window.initialInfo.status == "failed"
              )
                return;
              window.locked = true;
              MapUtils.setStatus(data["status"]);
              MapUtils.addMessage(data["message"]);
              MapUtils.displayCoordinates([data["coordinates"]]);
              break;
            case "message":
              if (
                window.initialInfo.status == "delivered" ||
                window.initialInfo.status == "failed"
              )
                return;
              MapUtils.addMessage(data["message"]);
              break;
            case "cancel_delivery":
              if (
                window.initialInfo.status == "delivered" ||
                window.initialInfo.status == "failed"
              )
                return;
              MapUtils.setStatus(data["status"]);
              MapUtils.addMessage(data["message"]);
              MapUtils.cancelDelivery();
              break;
            case "created_fulfillment":
              if (window.initialInfo.status != "requested") return;
              MapUtils.setOrderFulfillmentDate(data["date"]);
              MapUtils.setStatus(data["status"]);
              break;
            default:
              break;
          }
        },
      },
    );
  }
}

store.subscribe(() => handleConnection(store));
